import { Component, Input } from '@angular/core';
import { ApplicationStateService } from '../../../services/application-state.service';
import { SidebarService } from '../../../services/sidebar.service';
import { SidebarChangedEvent } from '../../../utils/events/sidebar-changed-event';
import { WhiteboardDrawingContentComponent } from '../whiteboard-drawing-content/whiteboard-drawing-content.component';
import { BackgroundImageDirective } from '../../../directives/background-image.directive';
import { AssetPipe } from '../../../pipes/asset.pipe';
import { RoutePipe } from '../../../pipes/route.pipe';

@Component({
    selector: 'app-user-menu',
    templateUrl: './user-menu.component.html',
    styleUrls: ['./user-menu.component.scss'],
    standalone: true,
    imports: [
        BackgroundImageDirective,
        AssetPipe,
        RoutePipe
    ]
})
export class UserMenuComponent {
    @Input() activeComponent: any;

    constructor(public applicationStateService: ApplicationStateService, public sidebarService: SidebarService) {
    }

    openWhiteboardsInSidebar(): void {
        this.sidebarService.triggerSidebarChangeEvent(new SidebarChangedEvent(true, WhiteboardDrawingContentComponent));
    }
}
